/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, May 2020
 *
 *****************************************************************************/

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import HelpOutline from "@material-ui/icons/HelpOutline";
import {
  updateShowInfoWindowCheckBox,
  updateShowWorkOrderUserInfoCheckBox,
} from "./../../../store/actions";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { constant } from "./../../../shared/constants/constants";
import Tooltip from "./../../../Tooltip/Tooltip";

const useStyles = makeStyles((theme) => ({
  root: {
    "&$checked": {
      color: "#8fa225",
    },
  },
  checked: {},
  formCtrlRoot: {
    marginRight: "4px",
  },
  formCtrl: {
    fontSize: "14px",
  },
}));

// plot info windows to all all geometries on map
const InfoWindowCheckBoxCard = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.ui.isLoading, shallowEqual);
  const isChecked = useSelector(
    (state) => state.geoUtil.showInfoWindow,
    shallowEqual
  );

  // handle changes happen in check box
  const handleCheckboxChange = (event) => {
    // set check box status accordingly in state
    dispatch(updateShowInfoWindowCheckBox(event.target.checked));
    if (event.target.checked) {
      // set workOrder user checkbox check box status to false if true
      dispatch(updateShowWorkOrderUserInfoCheckBox(!event.target.checked));
    }
  };

  const classes = useStyles();

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <FormControlLabel
          classes={{ label: classes.formCtrl, root: classes.formCtrlRoot }}
          control={
            <Checkbox
              checked={isChecked}
              disabled={isLoading}
              onChange={handleCheckboxChange}
              name="infoWindow"
              classes={{
                root: classes.root,
                checked: classes.checked,
              }}
            />
          }
          label={constant.SHOW_ALL_GEOMETRIES_INFO}
        />
        <Tooltip
          style={{ color: "grey" }}
          title={constant.ALLOW_TO_SEE_NAME_OF_PROPERTY_IN_MAP_SECTION}
          arrow>
          <HelpOutline />
        </Tooltip>
      </div>
    </div>
  );
};

export default InfoWindowCheckBoxCard;
